// extracted by mini-css-extract-plugin
export default {"name":"name--mp-Qvrnj","role":"role--mp-JP_IY","desc":"desc--mp-RvNFF"};